import * as editVisitDetailsActions from '../actions/editVisitDetails';

const defaultState = {
    form: {
        initialValues: {},
        initialStatus: {
            errors: {},
        },
    },
};

export default function (state = defaultState, action) {
    switch (action.type) {
        case editVisitDetailsActions.FORM_REFRESHED:
            return {
                ...state,
                form: action.form,
            };
        case editVisitDetailsActions.RESET:
            return defaultState;
        default:
            return state;
    }
}
